/**
 * ID generation utility with secure default and safe fallback.
 * - Uses globalThis.crypto.randomUUID() when available
 * - Falls back to time + random for environments without crypto
 */
export function generateId(): string {
  const uuid = (globalThis as any)?.crypto?.randomUUID?.();
  if (typeof uuid === "string") return uuid;

  const time = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 10);
  const extra = Math.random().toString(36).slice(2, 6);
  return `${time}-${rand}${extra}`;
}
